import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Ensure old service workers (if any) don't keep serving stale bundles.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .getRegistrations()
    .then((registrations) => registrations.forEach((reg) => reg.unregister()))
    .catch(() => {});
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
